<template lang="pug">
.form-element(:class="align + '-align'")
    input(
        :id="name",
        :type="type",
        :name="name",
        v-if="type != 'textarea' && type != 'submit'",
        v-model="inputVal"
    )
    textarea(
        :id="name",
        rows="4",
        :name="name",
        v-else-if="type == 'textarea'",
        v-model="inputVal"
    )
    label(
        :for="name",
        v-if="type != 'submit'",
        :class="{ moved: value != '' }"
    ) {{ label }}
</template>

<script>
export default {
    name: "contact-form-field",
    props: {
        label: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        align: {
            type: String,
            required: false,
            default: "left",
        },
        val: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            value: "",
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(v) {
                this.value = v;
                this.$emit("input", v);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.form-element {
    position: relative;
    padding-top: 1.2rem;

    &.right-align {
        display: flex;
        justify-content: flex-end;
    }

    &:not(:last-child) {
        margin-bottom: 2.4rem;
    }

    label {
        position: absolute;
        font-size: 1.6rem;
        top: 2.3rem;
        left: 1.6rem;
        pointer-events: none;
        font-weight: 500;
        color: $cl-cream-darker;
        transition: top 100ms ease-in-out, font-size 100ms ease-in-out,
            color 100ms ease-in-out;
    }

    input,
    textarea {
        width: 100%;
        border: 1px solid $cl-cream-darker;
        background-color: transparent;
        padding: 1rem 1.6rem;
        background-color: $cl-cream;
        box-sizing: border-box;
        font-size: 1.6rem;
    }

    input:focus + label,
    textarea:focus + label {
        top: -1.2rem;
        font-size: 1.2rem;
        color: $cl-red;
    }

    label.moved {
        top: -1.2rem;
        font-size: 1.2rem;
        color: $cl-red;
    }
}
</style>